import styled from 'styled-components';

export const Container: any = styled.div`
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    padding: 0 10px;
`;